"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.events = exports.StaticContentEnvironmentUrl = exports.SidebarLogEvent = exports.SidebarCypressTestAttribute = exports.NitroTestAttribute = exports.LanguageDirection = exports.HelpcenterEnvironmentUrl = exports.CustomHeaders = exports.BookingStatus = exports.ArticleVoteType = exports.ArticleFeedbackType = exports.ArticleFeedbackOptionMessage = exports.ARTICLE_CATEGORY_ID = void 0;
let HelpcenterEnvironmentUrl;
exports.HelpcenterEnvironmentUrl = HelpcenterEnvironmentUrl;
(function (HelpcenterEnvironmentUrl) {
  HelpcenterEnvironmentUrl["PRODUCTION"] = "https://help-graphql.kiwi.com";
  HelpcenterEnvironmentUrl["SANDBOX"] = "https://help-graphql.fe-sandbox.skypicker.com";
})(HelpcenterEnvironmentUrl || (exports.HelpcenterEnvironmentUrl = HelpcenterEnvironmentUrl = {}));
let StaticContentEnvironmentUrl;
exports.StaticContentEnvironmentUrl = StaticContentEnvironmentUrl;
(function (StaticContentEnvironmentUrl) {
  StaticContentEnvironmentUrl["PRODUCTION"] = "https://static-data.kiwi.com";
  StaticContentEnvironmentUrl["SANDBOX"] = "https://static-data-sandbox.kiwi.com";
})(StaticContentEnvironmentUrl || (exports.StaticContentEnvironmentUrl = StaticContentEnvironmentUrl = {}));
let CustomHeaders;
exports.CustomHeaders = CustomHeaders;
(function (CustomHeaders) {
  CustomHeaders["KB_LANGUAGE"] = "Accept-Language";
})(CustomHeaders || (exports.CustomHeaders = CustomHeaders = {}));
let ArticleVoteType;
exports.ArticleVoteType = ArticleVoteType;
(function (ArticleVoteType) {
  ArticleVoteType["UP"] = "up";
  ArticleVoteType["DOWN"] = "down";
})(ArticleVoteType || (exports.ArticleVoteType = ArticleVoteType = {}));
let ARTICLE_CATEGORY_ID;
exports.ARTICLE_CATEGORY_ID = ARTICLE_CATEGORY_ID;
(function (ARTICLE_CATEGORY_ID) {
  ARTICLE_CATEGORY_ID[ARTICLE_CATEGORY_ID["PRIMARY"] = 172] = "PRIMARY";
  ARTICLE_CATEGORY_ID[ARTICLE_CATEGORY_ID["SECONDARY"] = 191] = "SECONDARY";
  ARTICLE_CATEGORY_ID[ARTICLE_CATEGORY_ID["CHECKIN_AND_DOCUMENTS"] = 145] = "CHECKIN_AND_DOCUMENTS";
  ARTICLE_CATEGORY_ID[ARTICLE_CATEGORY_ID["MAKING_CHANGES"] = 266] = "MAKING_CHANGES";
  ARTICLE_CATEGORY_ID[ARTICLE_CATEGORY_ID["CHANGES_DELAYS_AND_CANCELLATIONS"] = 272] = "CHANGES_DELAYS_AND_CANCELLATIONS";
})(ARTICLE_CATEGORY_ID || (exports.ARTICLE_CATEGORY_ID = ARTICLE_CATEGORY_ID = {}));
let ArticleFeedbackType;
exports.ArticleFeedbackType = ArticleFeedbackType;
(function (ArticleFeedbackType) {
  ArticleFeedbackType["NotAccurate"] = "NOT_ACCURATE";
  ArticleFeedbackType["NeedFurtherAssistance"] = "NEED_FURTHER_ASSISTANCE";
  ArticleFeedbackType["DontLike"] = "DONT_LIKE";
  ArticleFeedbackType["AllGood"] = "ALL_GOOD";
  ArticleFeedbackType["InformationCouldBeEasierToFind"] = "INFORMATION_COULD_BE_EASIER_TO_FIND";
  ArticleFeedbackType["CouldBeBetter"] = "COULD_BE_BETTER";
  ArticleFeedbackType["Other"] = "OTHER";
})(ArticleFeedbackType || (exports.ArticleFeedbackType = ArticleFeedbackType = {}));
const ArticleFeedbackOptionMessage = {
  [ArticleFeedbackType.NotAccurate]: 'notAccurate',
  [ArticleFeedbackType.NeedFurtherAssistance]: 'needFurtherAssistance',
  [ArticleFeedbackType.DontLike]: 'dontLike',
  [ArticleFeedbackType.AllGood]: 'allGood',
  [ArticleFeedbackType.InformationCouldBeEasierToFind]: 'informationCouldBeEasierToFind',
  [ArticleFeedbackType.CouldBeBetter]: 'couldBeBetter',
  [ArticleFeedbackType.Other]: 'other'
};
exports.ArticleFeedbackOptionMessage = ArticleFeedbackOptionMessage;
let SidebarCypressTestAttribute;
exports.SidebarCypressTestAttribute = SidebarCypressTestAttribute;
(function (SidebarCypressTestAttribute) {
  SidebarCypressTestAttribute["MAIN_SCREEN_HEADER"] = "MainScreenHeader";
  SidebarCypressTestAttribute["MAIN_SCREEN_CATEGORY_TILE"] = "CategoryTile";
  SidebarCypressTestAttribute["MAIN_SCREEN_CATEGORY_LIST"] = "FAQItemList";
  SidebarCypressTestAttribute["BREADCRUMBS"] = "faq-breadcrumbs";
  SidebarCypressTestAttribute["CATEGORY_SCREEN_ITEMS_LIST"] = "FAQItemList";
  SidebarCypressTestAttribute["CATEGORY_SCREEN_ITEMS_HEADER"] = "FAQItemList_Header";
  SidebarCypressTestAttribute["CATEGORY_SCREEN_ARTICLE_TILE"] = "ArticleTile";
  SidebarCypressTestAttribute["CATEGORY_SCREEN_CATEGORY_TILE"] = "CategoryTile";
  SidebarCypressTestAttribute["CATEGORY_SCREEN_CONTACT_TITLE"] = "text-contact-us-button";
  SidebarCypressTestAttribute["ARTICLE_SCREEN_ARTICLE"] = "Article";
  SidebarCypressTestAttribute["ARTICLE_SCREEN_ARTICLE_TITLE"] = "Article_Title";
  SidebarCypressTestAttribute["ARTICLE_SCREEN_ARTICLE_CONTENT"] = "ArticleContent_Text";
  SidebarCypressTestAttribute["ARTICLE_SCREEN_ARTICLE_NOTFOUND"] = "articleNotFound";
  SidebarCypressTestAttribute["ARTICLE_SCREEN_ARTICLE_MODULE_TITLE"] = "Article_Module_Title";
  SidebarCypressTestAttribute["ARTICLE_ADDITIONAL_FEEDBACK"] = "ArticleFeedback";
  SidebarCypressTestAttribute["ARTICLE_ADDITIONAL_FEEDBACK_SUBMIT"] = "sendAdditionalFeedback";
  SidebarCypressTestAttribute["ARTICLE_FEEDBACK_OPTION"] = "articleFeedbackOption";
  SidebarCypressTestAttribute["ARTICLE_FEEDBACK_SUBMIT"] = "sendFeedback";
  SidebarCypressTestAttribute["ARTICLE_SCREEN_CONTACT_TITLE"] = "text-contact-us-button";
  SidebarCypressTestAttribute["ARTICLE_VOTE_UP"] = "upVote";
  SidebarCypressTestAttribute["ARTICLE_VOTE_DOWN"] = "downVote";
  SidebarCypressTestAttribute["RELATED_ARTICLES_CONTAINER"] = "relatedArticles";
  SidebarCypressTestAttribute["RELATED_ARTICLES_LIST"] = "FAQItemList";
  SidebarCypressTestAttribute["RELATED_ARTICLES_TILE"] = "ArticleTile";
  SidebarCypressTestAttribute["CONTACT_US_BUTTON"] = "contact-us-button";
  SidebarCypressTestAttribute["ERROR_SCREEN_CONTACT_US_BUTTON"] = "contactUs";
  SidebarCypressTestAttribute["SEARCHBAR_INPUT"] = "SearchBarInput";
  SidebarCypressTestAttribute["SEARCHBAR_INPUT_RESET"] = "SearchBarInput-ResetButton";
  SidebarCypressTestAttribute["SEARCHBAR_INPUT_RESULT_TILE"] = "ArticleTile";
  SidebarCypressTestAttribute["SEARCHBAR_INPUT_RESULTS"] = "SearchResults-FAQList";
  SidebarCypressTestAttribute["SEARCHBAR_INPUT_RESULTS_EMPTY"] = "noSearchResults";
  SidebarCypressTestAttribute["SIGNIN_BUTTON"] = "signIn";
  SidebarCypressTestAttribute["SIGNIN_CARD"] = "signInCard";
  SidebarCypressTestAttribute["ERROR"] = "StaticFAQError";
  SidebarCypressTestAttribute["DRAWER_CONTAINER"] = "HelpSidebarDrawerOverlay";
  SidebarCypressTestAttribute["SIDEBAR_CONTAINER"] = "SmartFAQHelp";
  SidebarCypressTestAttribute["BOOKING_CARD_TRIP_SELECTION"] = "otherBooking";
  SidebarCypressTestAttribute["BOOKING_CARD_TRIP_DETAILS"] = "tripInfo";
  SidebarCypressTestAttribute["BOOKING_CARD_TRIP_DEPARTURE"] = "FromTo_departureNameTag";
  SidebarCypressTestAttribute["BOOKING_CARD_TRIP_DIRECTION"] = "FromTo_flightDirectionIcon";
  SidebarCypressTestAttribute["BOOKING_CARD_TRIP_ARRIVAL"] = "FromTo_arrivalNameTag";
  SidebarCypressTestAttribute["BOOKING_MODAL_UPCOMING_BOOKINGS"] = "upcoming-bookings";
  SidebarCypressTestAttribute["BOOKING_MODAL_SELECT_TRIP"] = "compactBookingCard_TextLink";
  SidebarCypressTestAttribute["BOOKING_MODAL_LOAD_MORE"] = "loadMoreButton";
  SidebarCypressTestAttribute["BOOKING_MODAL_PAST_BOOKINGS"] = "pastBookings";
  SidebarCypressTestAttribute["NOT_FOUND"] = "routeNotFound";
  SidebarCypressTestAttribute["TOOLING_BUTTON"] = "toolingButton";
  SidebarCypressTestAttribute["EMERGENCIES_CONTAINER"] = "Emergency-Alert";
  SidebarCypressTestAttribute["EMERGENCIES_HEADER"] = "EmergencyHeader";
  SidebarCypressTestAttribute["EMERGENCIES_ITEM"] = "Emergency-Alert";
})(SidebarCypressTestAttribute || (exports.SidebarCypressTestAttribute = SidebarCypressTestAttribute = {}));
let BookingStatus;
exports.BookingStatus = BookingStatus;
(function (BookingStatus) {
  BookingStatus["CANCELLING"] = "cancelling";
  BookingStatus["CLOSED"] = "closed";
  BookingStatus["CONFIRMED"] = "confirmed";
  BookingStatus["FAILED"] = "failed";
  BookingStatus["REFUNDED"] = "refunded";
  BookingStatus["REFUNDING"] = "refunding";
  BookingStatus["NEW"] = "new";
})(BookingStatus || (exports.BookingStatus = BookingStatus = {}));
let NitroTestAttribute;
exports.NitroTestAttribute = NitroTestAttribute;
(function (NitroTestAttribute) {
  NitroTestAttribute["MOBILE_BREADCRUMB_BACK"] = "BreadcrumbsBack";
})(NitroTestAttribute || (exports.NitroTestAttribute = NitroTestAttribute = {}));
let LanguageDirection;
exports.LanguageDirection = LanguageDirection;
(function (LanguageDirection) {
  LanguageDirection["RTL"] = "rtl";
  LanguageDirection["LTR"] = "ltr";
})(LanguageDirection || (exports.LanguageDirection = LanguageDirection = {}));
const defaults = {
  category: 'sfaq',
  owner: '@smartfaq-fe-devs',
  version: 1,
  destinations: {
    logmole: true,
    bigQuery: true,
    datadog: true
  }
};
let SidebarLogEvent;
exports.SidebarLogEvent = SidebarLogEvent;
(function (SidebarLogEvent) {
  SidebarLogEvent["SIGN_IN_BUTTON_CLICKED"] = "SIGN_IN_BUTTON_CLICKED";
  SidebarLogEvent["CATEGORY_CLICKED"] = "CATEGORY_CLICKED";
  SidebarLogEvent["FAQ_ARTICLE_OPENED"] = "FAQ_ARTICLE_OPENED";
  SidebarLogEvent["FAQ_ARTICLE_CLOSED"] = "FAQ_ARTICLE_CLOSED";
  SidebarLogEvent["FEEDBACK_REASON_SUBMIT"] = "FEEDBACK_REASON_SUBMIT";
  SidebarLogEvent["LINK_ON_ARTICLE_CLICKED"] = "LINK_ON_ARTICLE_CLICKED";
  SidebarLogEvent["BOOKING_CARD_LOADED"] = "BOOKING_CARD_LOADED";
  SidebarLogEvent["SELECT_OTHER_BOOKING_CLICKED"] = "SELECT_OTHER_BOOKING_CLICKED";
  SidebarLogEvent["HELPDESK_MESSAGES_BUTTON_CLICKED"] = "HELPDESK_MESSAGES_BUTTON_CLICKED";
  SidebarLogEvent["ERROR"] = "ERROR";
  SidebarLogEvent["FAQ_CONTENT_LINK_CLICKED"] = "FAQ_CONTENT_LINK_CLICKED";
  SidebarLogEvent["FAQ_CATEGORY_CLICK"] = "FAQ_CATEGORY_CLICK";
  SidebarLogEvent["FAQ_SIDEBAR_OPENED"] = "FAQ_SIDEBAR_OPENED";
  SidebarLogEvent["FAQ_SIDEBAR_CLOSED"] = "FAQ_SIDEBAR_CLOSED";
  SidebarLogEvent["CONTACT_US_BUTTON_CLICKED"] = "CONTACT_US_BUTTON_CLICKED";
  SidebarLogEvent["LINK_CONTACT_US_CLICKED"] = "LINK_CONTACT_US_CLICKED";
  SidebarLogEvent["FAQ_SEARCH"] = "FAQ_SEARCH";
  SidebarLogEvent["FAQ_SEARCH_SCREEN_OPENED"] = "FAQ_SEARCH_SCREEN_OPENED";
  SidebarLogEvent["FAQ_VOTE_UP"] = "FAQ_VOTE_UP";
  SidebarLogEvent["FAQ_VOTE_DOWN"] = "FAQ_VOTE_DOWN";
  SidebarLogEvent["COMMENT_LIMIT_REACHED"] = "COMMENT_LIMIT_REACHED";
  SidebarLogEvent["FAQ_FEEDBACK_COMMENT_SUBMIT"] = "FAQ_FEEDBACK_COMMENT_SUBMIT";
  SidebarLogEvent["FAQ_FEEDBACK_REASON_SUBMIT"] = "FAQ_FEEDBACK_REASON_SUBMIT";
  SidebarLogEvent["RELATED_ARTICLE_CLICKED"] = "RELATED_ARTICLE_CLICKED";
  SidebarLogEvent["TOOLING_BUTTON_CLICKED"] = "TOOLING_BUTTON_CLICKED";
  SidebarLogEvent["HELPFULNESS_SUCCESS"] = "HELPFULNESS_SUCCESS";
  SidebarLogEvent["HELPFULNESS_FAIL"] = "HELPFULNESS_FAIL";
  SidebarLogEvent["ARTICLE_MODULE_CONTENT_ITEM_CLICKED"] = "ARTICLE_MODULE_CONTENT_ITEM_CLICKED";
  SidebarLogEvent["ARTICLE_MODULE_OPENED"] = "ARTICLE_MODULE_OPENED";
})(SidebarLogEvent || (exports.SidebarLogEvent = SidebarLogEvent = {}));
const events = {
  [SidebarLogEvent.SIGN_IN_BUTTON_CLICKED]: {
    ...defaults,
    action: 'sign in button clicked'
  },
  [SidebarLogEvent.CATEGORY_CLICKED]: {
    ...defaults,
    action: 'category clicked'
  },
  [SidebarLogEvent.FAQ_ARTICLE_OPENED]: {
    ...defaults,
    action: 'faq article opened'
  },
  [SidebarLogEvent.FAQ_ARTICLE_CLOSED]: {
    ...defaults,
    action: 'faq article closed'
  },
  [SidebarLogEvent.FEEDBACK_REASON_SUBMIT]: {
    ...defaults,
    action: 'feedback reason form submitted'
  },
  [SidebarLogEvent.LINK_ON_ARTICLE_CLICKED]: {
    ...defaults,
    action: 'link on article clicked'
  },
  [SidebarLogEvent.BOOKING_CARD_LOADED]: {
    ...defaults,
    action: 'booking card loaded'
  },
  [SidebarLogEvent.SELECT_OTHER_BOOKING_CLICKED]: {
    ...defaults,
    action: 'select another booking button clicked'
  },
  [SidebarLogEvent.HELPDESK_MESSAGES_BUTTON_CLICKED]: {
    ...defaults,
    action: 'helpdesk messages clicked'
  },
  [SidebarLogEvent.ERROR]: {
    ...defaults,
    action: 'error'
  },
  [SidebarLogEvent.FAQ_CONTENT_LINK_CLICKED]: {
    ...defaults,
    action: 'link within article clicked'
  },
  [SidebarLogEvent.FAQ_CATEGORY_CLICK]: {
    ...defaults,
    action: 'category clicked'
  },
  [SidebarLogEvent.FAQ_SIDEBAR_OPENED]: {
    ...defaults,
    action: 'faqs sidebar opened'
  },
  [SidebarLogEvent.FAQ_SIDEBAR_CLOSED]: {
    ...defaults,
    action: 'faqs sidebar closed'
  },
  [SidebarLogEvent.CONTACT_US_BUTTON_CLICKED]: {
    ...defaults,
    action: 'contact us button clicked'
  },
  [SidebarLogEvent.LINK_CONTACT_US_CLICKED]: {
    ...defaults,
    action: 'contact us link clicked'
  },
  [SidebarLogEvent.FAQ_SEARCH]: {
    ...defaults,
    action: 'search'
  },
  [SidebarLogEvent.FAQ_SEARCH_SCREEN_OPENED]: {
    ...defaults,
    action: 'search results screen opened'
  },
  [SidebarLogEvent.FAQ_VOTE_UP]: {
    ...defaults,
    action: 'upvote'
  },
  [SidebarLogEvent.FAQ_VOTE_DOWN]: {
    ...defaults,
    action: 'downvote'
  },
  [SidebarLogEvent.COMMENT_LIMIT_REACHED]: {
    ...defaults,
    action: 'comment limit reached'
  },
  [SidebarLogEvent.FAQ_FEEDBACK_COMMENT_SUBMIT]: {
    ...defaults,
    action: 'feedback comment submitted'
  },
  [SidebarLogEvent.FAQ_FEEDBACK_REASON_SUBMIT]: {
    ...defaults,
    action: 'feedback reason submitted'
  },
  [SidebarLogEvent.RELATED_ARTICLE_CLICKED]: {
    ...defaults,
    action: 'related article clicked'
  },
  [SidebarLogEvent.TOOLING_BUTTON_CLICKED]: {
    ...defaults,
    action: 'tooling button clicked'
  },
  [SidebarLogEvent.HELPFULNESS_SUCCESS]: {
    ...defaults,
    action: 'helpfulness success'
  },
  [SidebarLogEvent.HELPFULNESS_FAIL]: {
    ...defaults,
    action: 'helpfulness fail'
  },
  [SidebarLogEvent.ARTICLE_MODULE_CONTENT_ITEM_CLICKED]: {
    ...defaults,
    action: 'article module content item clicked'
  },
  [SidebarLogEvent.ARTICLE_MODULE_OPENED]: {
    ...defaults,
    action: 'article module opened via a deep link'
  }
};
exports.events = events;